import { Trans } from "../utils/i18n";
import React from "react";
import {validateEmailRegEx, validatePhoneNumber} from "../Shared/FormField";
import {usePage} from "@inertiajs/inertia-react";
import WarningIcon from "@material-ui/icons/Warning";
import {addressConfigB2b} from "./components/address_b2b";

const validProblem = (values, orderEntryState) => {
    const selectedProduct = orderEntryState && orderEntryState.products && orderEntryState.products?.find((item) => item.id === parseInt(values.product))
        || orderEntryState?.serialNumber?.product;
    const currentProblem = selectedProduct && selectedProduct.problems && selectedProduct.problems.find(item => parseInt(values.problem_1) === item.id);
    const currentProblem2 = currentProblem && currentProblem.problems?.find(item => parseInt(values.problem_2) === item.id);

    return values.problem_1 && values.problem_2 && !currentProblem2?.education_text;
};

export const orderEntryConfigSegwayB2B = {
    "sizes": {
        "forth": 3,
        "third": 4,
        "half": 6,
        "full": 12
    },
    "enableStepper": true,
    "heading": <Trans i18nKey="orderEntry.basicData">Basic data</Trans>,
    "defaultValues": {
        "private_or_company": "company",
    },
    "groups": [
        {
            "heading": <Trans i18nKey="orderEntry.productSelection">Product selection</Trans>,
            "description": <Trans i18nKey="orderEntry.productSelection.description"></Trans>,
            "id": "product_selection",
            "fields": [
                {
                    "size": "full",
                    "name": "productselectdynamic1",
                    "component": "serialnumberdynamic",
                    "mode": "serialnumber",
                    "disableColorSelection": true,
                    "referenceFieldRequired": true,
                    "validateSerialNumber": value => /^.{14}$/.test(value) ? undefined : <Trans i18nKey="serialNumber.write14chars">You have to provide exactly 14 characters</Trans>,
                },
            ],
            "noNextButton": false,
        },
        {
            "heading": <Trans i18nKey="orderEntry.addressContact">Contact information</Trans>,
            "description": <Trans i18nKey="orderEntry.addressContact.description">Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.</Trans>,
            "id": "address",
            "fields": [
                {
                    "size": "full",
                    "component": "callback",
                    "callback": (values) => <div className={'mt-3 font-bold'}><Trans i18nKey={'orderEntry.addressContact'}>Contact information</Trans></div>,
                },
                ...addressConfigB2b,
                {
                    "name": "terms_of_service",
                    "label": <Trans i18nKey="orderEntry.termsandconditions.label">I have read and accept the <a href={route('termsandconditions')} target={'_blank'}>Terms & Conditions</a> and the <a href={route('privacy')} target={'_blank'}>Privacy Statement</a></Trans>,
                    "size": "full",
                    "type": "checkbox",
                    "required": true
                },
            ],
            "conditionFunction": (values, orderEntryState) => {
                return ( values.products || []).length > 0;
            }
        }
    ],
    "actions": [
        {
            "fields": [
                {
                    "text": <Trans i18nKey="orderEntry.send">Send</Trans>,
                    "size": "half",
                    "component": "button",
                    "action": "next",
                    "color": "secondary",
                    "conditionFunction": (values, orderEntryState) => {
                        const validAddress = values.name && values.city && values.street && values.zip && values.country_id && validatePhoneNumber.test(values.phone) && validateEmailRegEx.test(values.email);

                        return ( values.terms_of_service ) && validAddress && (values.custom_address || values.address);
                    }
                }
            ]
        }
    ],
    "isMultiOrder": true,
    "success": function ({ response }) {
        const orders = response?.filter(item => item.success)?.map(item => item.order);
        const notSuccessfull = response?.filter(item => !item.success);

        return (
            <div>
                <h2 style={{ marginTop: 50 }} className={'text-center'}>
                    {
                        notSuccessfull.length === 0 ?
                        <Trans i18nKey="orderEntry.ordersSuccessfullyCreated">Orders successfully created</Trans>
                            :
                        <Trans i18nKey="orderEntry.orderCreatedWithErrors">Orders created with errors</Trans>

                    }
                </h2>

                <div className="mt-8 flow-root">
                    <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                        <div className="inline-block min-w-full py-2 align-middle">
                            <table className="min-w-full">
                                <thead>
                                <tr>
                                    <th
                                        scope="col"
                                        className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6 lg:pl-8"
                                    >
                                        <Trans i18nKey="ordernumber">Order number</Trans>
                                    </th>
                                    <th scope="col"
                                        className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                                    >
                                        <Trans i18nKey="orderEntry.requestType">Request type</Trans>
                                    </th>
                                    <th scope="col"
                                        className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                        <Trans i18nKey="orderEntry.serialNumber.serialNumber">Serial number</Trans>
                                    </th>
                                    <th scope="col"
                                        className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                        <Trans i18nKey="queueDetail.product">Product</Trans>
                                    </th>
                                    <th scope="col"
                                        className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                        <Trans i18nKey="orderEntry.serialDynamic.warranty">Warranty</Trans>
                                    </th>
                                </tr>
                                </thead>
                                <tbody className=" bg-white">
                                {notSuccessfull.map((order) => {
                                    return (
                                        <tr key={order.product.serialnumber}
                                            className={'border border-t-2 border-t-black border-solid'}>
                                            <td className="py-4 pl-4 pr-3 text-sm font-medium sm:pl-6 lg:pl-8 text-red-500 ">
                                                <div className={'flex  items-center '}>
                                                    <WarningIcon className={'w-5 h-5 text-red-500 ml-1'}/>
                                                    { order.product.serialnumber }
                                                </div>
                                                <p className={'block'}>
                                                    <Trans i18nKey={'orderEntry.multipleOrders.generalError'}>
                                                        Error while creating order. Order data was not saved. Please try again.
                                                    </Trans>
                                                </p>
                                            </td>
                                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                                { order.product.requesttype }
                                            </td>
                                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                            </td>
                                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                            </td>
                                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                            </td>
                                        </tr>
                                    );
                                })}
                                {orders.map((order) => {
                                    return (
                                        <tr key={order.number}
                                            className={'border border-t-2 border-t-black border-solid'}>
                                            <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6 lg:pl-8">
                                                <a
                                                    href={route('track.index', {serialnumber: order?.number})}
                                                    className={'underline text-secondary'}
                                                    target={'_blank'}
                                                >
                                                    {order.number}
                                                </a>
                                            </td>
                                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                                {
                                                    order?.requesttype?.name
                                                }
                                            </td>
                                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                                {
                                                    order?.orderdetails?.[0]?.serialnumber
                                                }
                                            </td>
                                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                                {
                                                    order?.orderdetails?.[0]?.product?.description
                                                }
                                            </td>
                                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                                {
                                                    order?.orderdetails?.[0]?.warranty === "in_warranty" ? <Trans
                                                            i18nKey="orderEntry.serialDynamic.warranty">Warranty</Trans> :
                                                        <Trans i18nKey="orderEntry.serialDynamic.noWarranty">No
                                                            warranty</Trans>
                                                }
                                            </td>
                                        </tr>
                                    );
                                })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                {/*<SuccessWrapper className={'bg-blue-100'}>*/}
                {/*    <p>*/}
                {/*        Your reference number is:*/}
                {/*    </p>*/}
                {/*    <p>*/}
                {/*        <b>{ response?.order?.batch_reference }</b>*/}
                {/*    </p>*/}
                {/*</SuccessWrapper>*/}
                {/*<div className={'text-right'}>*/}
                {/*    <MuiButton*/}
                {/*        style={{ marginTop: 50}}*/}
                {/*        variant="contained"*/}
                {/*        color={"secondary"}*/}
                {/*        href={'/'}*/}
                {/*        component={InertiaLink}*/}
                {/*    >*/}
                {/*        <Trans i18nKey="common.home">*/}
                {/*            Home*/}
                {/*        </Trans>*/}
                {/*    </MuiButton>*/}
                {/*</div>*/}
            </div>
        );
    }
}
